module.exports = __webpack_public_path__ + "static/media/Brionne_gaussian2.20ce812d.png";